var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInprogress(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 51",
    style: {
      enableBackground: "new 0 0 50 51"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#425EAB;stroke-width:3;stroke-miterlimit:2;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2,2.5h46 M20.8,9.9h8.4V13c0,2.1-4.2,4.2-4.2,4.2s-4.2-2.1-4.2-4.2V9.9z M10.4,2.5V13 c0,6.3,10.4,6.8,10.4,12.5S10.4,31.8,10.4,38v10.4 M39.6,2.5V13c0,6.3-10.4,6.8-10.4,12.5S39.6,31.8,39.6,38v10.4 M2,48.5h46  M16.6,44.4c0-4.2,8.4-8.4,8.4-8.4s8.4,4.2,8.4,8.4v4.1H16.6V44.4z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInprogress);
export default __webpack_public_path__ + "static/media/Inprogress.e71ba87bd4037c87cc0526ff16240a82.svg";
export { ForwardRef as ReactComponent };